export const GET_ALL_STANDINGS = "GET_ALL_STANDINGS";
export const CLEAR_STANDINGS = "CLEAR_STANDINGS";